import React from 'react';

import ChainExplorerIcon from 'components/wallet/icons/explorer/ChainExplorerIcon';
import {
  getBlockExplorerAddressUrl,
  getRewardsChain,
} from 'config/configUtils';
import { useSelector } from 'reduxState/store';

import { MenuItemType } from '../headerTypes';
import MenuItemRenderer from '../MenuItemRenderer';

function WalletBlockExplorerItem() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);

  const rewardsChain = getRewardsChain();
  if (!walletAddress) {
    return null;
  }

  return (
    <MenuItemRenderer
      menuItem={{
        type: 'DropdownMenuLink' as const,
        label: 'Block Explorer',
        to: getBlockExplorerAddressUrl(walletAddress, rewardsChain.config),
        icon: <ChainExplorerIcon />,
      }}
    />
  );
}

const walletBlockExplorerItem: MenuItemType = {
  type: 'MenuBox',
  Component: WalletBlockExplorerItem,
};

export default walletBlockExplorerItem;
